import React from 'react';
import PropTypes from 'prop-types';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import { ButtonWrapper } from 'components/ButtonWrapper';
import { Text } from 'atoms';

function ActionCell({ id }) {
	const navigate = useNavigate();
	return (
		<ButtonWrapper
			type="button"
			style={{
				padding: 4,
				minWidth: 32,
				minHeight: 32,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
			onClick={() => navigate(`/business-units/${id}`)}
		>
			<EyeOutlined style={{ fontSize: 18, color: '#1890ff' }} />
		</ButtonWrapper>
	);
}

ActionCell.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const StatusBadge = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 2px 14px;
	gap: 10px;
	width: 65px;
	height: 24px;
	background: #dbffd5;
	border-radius: 30px;
	flex: none;
	order: 0;
	flex-grow: 0;

	span {
		width: 37px;
		height: 20px;
		font-family: 'Inter', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: 0.16px;
		color: #07b123;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

const InactiveStatusBadge = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 2px 14px;
	gap: 10px;
	min-width: 82px;
	max-width: 90px;
	height: 24px;
	background: #ffe2e1;
	border-radius: 30px;
	flex: none;
	order: 0;
	flex-grow: 0;

	span {
		min-width: 54px;
		height: 20px;
		font-family: 'Inter', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: 0.16px;
		color: #ff4f30;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const localProjectColumns = [
	{
		title: 'Project',
		dataIndex: 'project_name',
		key: 'project_name',
		render: (project_name) => <Text overFlow="hidden">{project_name || ''}</Text>,
	},
	{
		title: 'Client',
		dataIndex: 'client_name',
		key: 'client_name',
		render: (client_name) => <Text overFlow="hidden">{client_name || ''}</Text>,
	},
	{
		title: 'Created Date',
		dataIndex: 'created_at',
		key: 'created_at',
		render: (created_at) => (
			<Text overFlow="hidden">
				{created_at ? new Date(created_at).toLocaleDateString('en-GB') : ''}
			</Text>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'action',
		render: (id) => (
			<Link to={`/projects/${id}`}>
				<EyeOutlined style={{ color: '#1890ff', fontSize: 18 }} />
			</Link>
		),
	},
];

export const BusinessUnitTableConfig = [
	{
		title: 'BU Name',
		dataIndex: 'name',
		key: 'name',
		hidden: false,
		render: (name) => <Text overFlow="hidden">{name || ''}</Text>,
	},
	{
		title: 'BU Code',
		dataIndex: 'code',
		key: 'code',
		hidden: false,
		render: (code) => <Text overFlow="hidden">{code || ''}</Text>,
	},
	{
		title: 'City Manager',
		dataIndex: 'city_manager_name',
		key: 'city_manager_name',
		hidden: false,
		render: (city_manager_name) => <Text overFlow="hidden">{city_manager_name || ''}</Text>,
	},
	{
		title: 'Status',
		dataIndex: 'is_active',
		key: 'is_active',
		hidden: false,
		render: (is_active) =>
			is_active ? (
				<StatusBadge>
					<span>Active</span>
				</StatusBadge>
			) : (
				<InactiveStatusBadge>
					<span>In-Active</span>
				</InactiveStatusBadge>
			),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => <ActionCell id={id} />,
	},
];
